import { AlertTriangle } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

interface LowStockBadgeProps {
  quantity: number;
  minStockAlert: number | null;
}

const LowStockBadge = ({ quantity, minStockAlert }: LowStockBadgeProps) => {
  // Si minStockAlert es null, no hay alerta configurada - mostrar solo cantidad
  if (minStockAlert === null) {
    return (
      <Badge variant="secondary" className="bg-muted text-muted-foreground">
        {quantity}
      </Badge>
    );
  }

  const isLowStock = quantity <= minStockAlert;
  const isCritical = quantity === 0;

  if (!isLowStock) {
    return (
      <Badge variant="secondary" className="bg-success/10 text-success border-success/20">
        {quantity}
      </Badge>
    );
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge 
            variant="destructive" 
            className={cn(
              "flex items-center gap-1",
              isCritical ? "bg-destructive" : "bg-warning text-warning-foreground"
            )}
          >
            <AlertTriangle size={12} />
            {quantity}
          </Badge>
        </TooltipTrigger>
        <TooltipContent>
          <p>
            {isCritical 
              ? 'Sin stock disponible' 
              : `Stock bajo (mínimo: ${minStockAlert})`
            }
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default LowStockBadge;
